import React from 'react'
import { Outlet, useLocation} from 'react-router-dom';
import styled from 'styled-components';
//Components
import Header from './Header';

export default function Layout({ children }) {

    const location = useLocation();
    const route=location.pathname.slice(0, location.pathname.lastIndexOf('/'));
    const customRoutes=['/ova','/home'];

    return (
        <Wrapper route={route} customRoutes={customRoutes}>
            <Header route={route} customRoutes={customRoutes}></Header>
            <main>
                <Outlet></Outlet>
            </main>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    background: rgb(67,97,238);
    background: -moz-linear-gradient(90deg, rgba(67,97,238,1) 0%, rgba(86,11,173,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(67,97,238,1) 0%, rgba(86,11,173,1) 100%);
    background: linear-gradient(90deg, rgba(67,97,238,1) 0%, rgba(86,11,173,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#4361ee",endColorstr="#560bad",GradientType=1);
    /*Fixed */
    ${({customRoutes, route}) => customRoutes?.includes(route) &&`
        margin-top:64px;
  `}
`;


